module.exports = __webpack_public_path__ + "static/media/img-keelo-product-2@3x.3695ff7c.png";